import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from './services/login/login.service';
import { AuthService } from './services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private loginService: LoginService, private authService: AuthService) { }
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.checkSession()) {
            // logged in so return true
            return true;
        }
        return false;
    }

    checkSession(): boolean {
        let flag: boolean = false;
        this.loginService.checkSession()
            .then((response) => {
                if (response != null) {
                    if (response == true) {
                        let userId = localStorage.getItem("mcmt_userId");
                        sessionStorage.setItem("mcmt_userID", userId)
                        let sessionUserId = sessionStorage.getItem("mcmt_userID");
                        if (sessionUserId == null) {
                            this.router.navigate(['/MCMaterial/Login']);
                            flag = false;
                        }
                    } else {
                        this.router.navigate(['/MCMaterial/Login']);
                        flag = false;
                    }
                }
                else {
                    this.router.navigate(['/MCMaterial/Login']);
                    flag = false;
                }

            },
                error => {
                    if (error.status === 401) {
                        this.router.navigate(['/MCMaterial/Login']);
                        flag = false;
                    }
                });

        return flag = true;
    }
}
